import type { FunctionComponent, PropsWithChildren } from 'react';

import { L10nText } from '../../services/uiTranslations/reactBindings/L10nText';
import type { AllowedGlobals } from '../../utils/window';
import { ButtonVariant } from '../controls/button/Button';
import { BlockingModalContent } from '../popup/content/BlockingModalContent';

import { ErrorBoundary } from './ErrorBoundary';

export const FinalErrorBoundary: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const windowObject = (window as AllowedGlobals).legacyMode ? window.parent : window;

  return (
    <ErrorBoundary
      fallback={
        <BlockingModalContent
          messageComponent={
            <L10nText tk="GENERIC_ERROR" placeholder="Please contact Customer Support for assistance" />
          }
          actions={[
            {
              label: <L10nText tk="OK" placeholder="OK" />,
              type: ButtonVariant.ACCENT,
              click: (): void => {
                windowObject.location.reload();
              },
            },
          ]}
          inCurtain
        />
      }
      critical
    >
      {children}
    </ErrorBoundary>
  );
};
